import { showToast } from "../components/NotifyToast.jsx";

const PT_HINT = " Subscreve a app a partir de 3,50 €/mês. Vê os planos em Conta > Gerir Subscrição.";
const EN_HINT = " Subscribe from €3.50/month. See plans in Account > Manage Subscription.";

export function withPlanUpgradeHint(message = "") {
  const base = String(message || "").trim();
  if (!base) return `❗ O teu plano não permite esta ação.${PT_HINT}`;
  if (
    base.includes("Gerir Subscrição.") ||
    base.includes("Manage Subscription.")
  ) {
    return base;
  }
  const lower = base.toLowerCase();
  const looksEnglish =
    lower.includes("your plan") ||
    lower.includes("does not allow") ||
    lower.includes("don't have permission") ||
    lower.includes("you don't have permission");
  return `${base}${looksEnglish ? EN_HINT : PT_HINT}`;
}

export function showPlanUpgradeToast(message, type = "warning") {
  showToast(withPlanUpgradeHint(message), type);
}
